<div class="container">
  <ng-container *ngFor="let btn of actions.buttons">
    <button class="button blank-button" [style.color]="btn.color" merriNoFocusLink (click)="onActionBtnClick(btn)" matRipple>
      {{ btn.text }}
    </button>
  </ng-container>
</div>
